import React from "react";
import { Card, Typography } from "antd";
import StatusIndicator from "../../Common/StatusIndicator";

const { Title } = Typography;

const EmployeeDetailCard = ({ employee }) => {
    if (!employee) return null;

    const formatDate = (dateString) => {
        if (!dateString) return "";
        return new Date(dateString).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short', 
            year: 'numeric'
        });
    };

    return (
        <Card className="employee-detail-card">
            <div className="section-header">
                <Title level={5} className="section-title">USER DETAILS</Title>
            </div>
            
            <div className="employee-detail-content">
                <div className="employee-info">
                    <div className="info-row">
                        <div className="info-label">
                            <strong>User Name</strong>
                            <strong className="separator">:</strong>
                        </div>
                        <div className="info-value">
                            <a 
                                href={`/profile/${encodeURIComponent(employee.email)}`} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="employee-profile-link"
                            >
                                {employee.fullName || `${employee.firstName || ''} ${employee.middleName || ''} ${employee.lastName || ''}`.trim()}
                            </a>
                        </div>
                    </div>

                    <div className="info-row">
                        <div className="info-label">
                            <strong>Status</strong>
                            <strong className="separator">:</strong>
                        </div>
                        <div className="info-value">
                            {employee.isActive ? (
                                <StatusIndicator status="active" />
                            ) : (
                                <span>
                                    Deactivated 
                                    {employee.jobTerminateDate && (
                                        <span> ({formatDate(employee.jobTerminateDate)})</span>
                                    )}
                                </span>
                            )}
                        </div>
                    </div>

                    <div className="info-row">
                        <div className="info-label">
                            <strong>Department</strong>
                            <strong className="separator">:</strong>
                        </div>
                        <div className="info-value">
                            {employee.department || employee.departmentName || '-'}
                        </div>
                    </div>
                </div>

                <div className="employee-stats">
                    <div className="stat-card">
                        <p><strong>Total Projects</strong></p>
                        <h3>{employee.totalProjects || employee.projects || 0}</h3>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EmployeeDetailCard;